import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {TgccLogo} from './TgccLogo';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {ButtonToolbar,DropdownButton,Dropdown} from 'react-bootstrap';

const containerStyle: React.CSSProperties = {
    height:'100px',
    width:'100%',
    textAlign:'center'
};
const navItemStyle: React.CSSProperties = {
    fontFamily:'Roboto !important',
    marginRight:'40px',
    fontSize: '18px',
    cursor:'pointer',
    color:'#3a54b4',
    ':hover':{
        color:'#c2b186',
    }
}
const navBar: React.CSSProperties = {
    display:'flex',
    alignSelf:'center',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent:'center',
    flexGrow:3
}
const topNav: React.CSSProperties = {
    width:'100%',
    backgroundColor:'white',
    height:'100px',
    display:'flex',
    flexDirection:'row',
    position:'fixed',
    zIndex:2,
    border:'1px solid #e9e6e6'
}
const topNavStyle: React.CSSProperties = {
    width:'131px',
    height:'40px',
    backgroundColor:'#3a54b4',
    margin:'13px 10px',
    lineHeight:'38px',
    padding:'5px',
    fontFamily:'Roboto !important',
    cursor:'pointer',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    color:'white'
}
const loggedIn : React.CSSProperties = {
    position:'absolute',
    right:'10%',
    top:'50px',
    fontFamily:'BarlowLight'
}

const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png');

const imgStyles : React.CSSProperties ={
    cursor:'pointer',
    width:'75px',
    height:'75px',
};
const txt: React.CSSProperties = {
    fontFamily:"AveriaSerifLightItalic",
    marginLeft:'20px',
}
const logoTxt: React.CSSProperties = {
    marginLeft:'40px',
    display:'flex',
    alignItems:'center',
    flexGrow:1
}
const rightNav: React.CSSProperties = {
    display:'flex',
}
const GCText: React.CSSProperties = {
    fontFamily:"BarlowMedium",
    marginLeft:'15px',
    fontSize:'15px'
}
const emailStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium'
}
const mobileNav: React.CSSProperties = {
    display:'flex'
}
const hamburger: React.CSSProperties = {
    backgroundImage:'url('+ Tgcc.ResolveUrl("~/images/hamburger_2.png"),
    height:'50px',
    width:'50px',
    backgroundPosition:'center',
    backgroundSize:'cover',
}

const hamburgerStyle: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl("~/images/hamburger_2.png") + ')',
    height: '50px',
    width: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0
};

const dropdownItemStyle: React.CSSProperties = {
    display: 'block',
    padding: '10px 15px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    borderBottom: '1px solid #eee',
    textTransform: 'uppercase',
    color: '#333'
};


const topLoginStyle = Object.assign({}, topNavStyle, {margin: '13px 10px 20px'});

class _CampusHeader extends React.Component < Tgcc.BaseProps, any > {
    openDashboard = () => {browserHistory.push(Tgcc.Routes.CampusDashboard)};
    openCSR = () => {browserHistory.push(Tgcc.Routes.CSR)};
    openDesign = () => {browserHistory.push(Tgcc.Routes.CampusDesignListView)};
    openCampus = () => {browserHistory.push(Tgcc.Routes.Campus)};
    openContact = () => {browserHistory.push(Tgcc.Routes.CampusContact)}
    openHowItWorks = () =>{browserHistory.push(Tgcc.Routes.CampusHowItWorks)};

   
    openProducts = () => {browserHistory.push(Tgcc.Routes.CampusProductCategoryListView)};
    openRegister = () =>{browserHistory.push(Tgcc.Routes.CampusRegister)}
    // openRegister = () =>{browserHistory.push(Tgcc.Routes.TShirtHero)} 
    openMerch = () => {browserHistory.push(Tgcc.Routes.CampusSchoolMerch)}
    loginUser = () => {
        browserHistory.push(Tgcc.Routes.CampusLogin)
    }

    logoutUser = () => {
        Tgcc.LogoutCampusUser(this.props.dispatch, this.props.state.LoginData);
                this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});

            this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});
    }

    getLoginLink(){
        if(this.props.state.LoginData){
            return <div style={topLoginStyle} className="logStyle" key={1} onClick={this.logoutUser}>Logout</div>
        }
        return <div  style={topLoginStyle} className="logStyle" key={2} onClick={this.loginUser}>Login</div>
    }
    getDashboardLink(){
        if(!this.props.state.LoginData){
            return <div style={topNavStyle} key={3} className="acctStyle" onClick={this.openRegister}>Create Account</div>
        }
        return <div style={topNavStyle} key={4} className="acctStyle" onClick={this.openDashboard}>Dashboard</div>
    }
    getUserName(){
        if(this.props.state.LoginData && this.props.state.LoginData.impersonate)
            return <div style={loggedIn}>Impersonating: {this.props.state.LoginData.impersonate}</div>
            
        if(this.props.state.UserInfo && this.props.state.UserInfo.email)
            return <div style={loggedIn} className='loggedStyle'>Logged in as: <span style={emailStyle}>{this.props.state.UserInfo.email}</span></div>
    }
    openProofEdit = () => {
            browserHistory.push(Tgcc.Routes.CampusProofEdit)
    };
    getMobile() {
        const logLink = this.getLoginLink();
        const dbLink = this.getDashboardLink();
    
        if (window.innerWidth <= 440) {
            return (
                <div style={mobileNav}>
                    <Dropdown>
                        <Dropdown.Toggle id="mobile-dropdown" style={hamburgerStyle} variant="light" />
                        <Dropdown.Menu>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="101" onClick={this.openCampus}>HOME</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="102" onClick={this.openDesign}>DESIGNS</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="103" onClick={this.openProofEdit}>START AN ORDER</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="105" onClick={this.openMerch}>SHOP YOUR SCHOOL</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="104" onClick={this.openProducts}>PRODUCTS</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div style={mobileNav} className='campuMobileLink'>
                        {logLink}
                        {dbLink}
                    </div>
                    {this.getUserName()}
                </div>
            );
        }
    
        // return desktop view
        return (
            <div style={topNav} className="maTopNav">
                <div onClick={this.openCampus} style={logoTxt} className="campusNvLogo">
                    <img src={imgFile} style={imgStyles} />
                </div>
                <div style={navBar} className="newCampusNv">
                    <div key={99} style={navItemStyle} onClick={this.openCampus}>HOME</div>
                    <div key={96} style={navItemStyle} onClick={this.openDesign}>DESIGNS</div>
                    <div key={97} style={navItemStyle} onClick={this.openProofEdit}>START AN ORDER</div>
                    <div key={94} style={navItemStyle} onClick={this.openMerch}>SHOP YOUR SCHOOL</div>
                    <div key={95} style={navItemStyle} onClick={this.openProducts}>PRODUCTS</div>
                </div>
                <div style={rightNav} className="logNav">
                    {logLink}
                    {dbLink}
                </div>
                {this.getUserName()}
            </div>
        );
    }
    
    render() {

        var navBar = this.getMobile()
        return (
            <div style={containerStyle} className="majorHdrDiv">                
              {navBar}
            </div>
        )

    }
    
}
const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state
    };
};

export var CampusHeader = connect(mapStateToProps)(Radium(_CampusHeader));